import {FaFacebook, FaInstagram, FaLinkedinIn} from 'react-icons/fa'
import styles from './Footer.module.css'

function Footer() {
    const anoAtual = new Date().getFullYear();
    return (
        <footer className={styles.footer}>
    
            <p className={styles.copyRight}><span>J&O Software</span> &copy; {anoAtual}</p>
        </footer>
    )
}

export default Footer